[
    "albumen",
    "albumin",
    "aldioxa",
    "allantoin",
    "alphahydroxyacids",
    "alphahydroxy acids",
    "alpha-hydroxy acids",
    "aminoacids",
    "amino acids",
    "aminosuccinate acid",
    "ammonium hydrolyzed protein",
    "aspartic acid",
    "aspic",
    "beta carotene",
    "biotin",
    "benzoic acid",
    "bristle",
    "calcium carbonate",
    "calcium hydroxide",
    "calcium lactate",
    "calcium oxide",
    "calcium phosphate",
    "calcium stearate",
    "capryl betaine",
    "caprylamine oxide",
    "caprylic acid",
    "carbonblack",
    "cetyl alcohol",
    "cetyl ether",
    "cetyl palmitate",
    "cetylalcohol",
    "cetylpalmitate",
    "chalk",
    "charcoal",
    "chitin",
    "cholecalciferol",
    "chymosin",
    "color",
    "colors",
    "civet",
    "cortico steroid",
    "corticosteroid",
    "cortisone",
    "cortisone corticosteroid",
    "dexpanthenol",
    "diglycerides",
    "disodiuminosinate",
    "dye",
    "dyes",
    "e129",
    "e133",
    "e170",
    "e322",
    "e470",
    "e570",
    "e585",
    "e631",
    "e640",
    "e901",
    "e910",
    "e920",
    "enzymes",
    "ergocalciferol",
    "estradiol",
    "fats",
    "fd and c colors",
    "fd&c colors",
    "felt",
    "gluconolactone",
    "glucosamine",
    "glutamic acid",
    "glycerides",
    "glycerol",
    "glycine",
    "glycogen",
    "hydrocortisone",
    "inositol",
    "insulin",
    "isopropyl myristate",
    "l-lactic acid",
    "lactic acid",
    "lecithin",
    "leucine",
    "linoleic acid",
    "lipids",
    "lipoids",
    "lysine",
    "mono and di-glycerides",
    "mono-diglycerides",
    "monoglycerides",
    "monoglycerides glycerides",
    "monosodium glutamate",
    "msg",
    "musk",
    "musk oil",
    "myristal ether sulfate",
    "myristic acid",
    "natural flavor",
    "natural flavorings",
    "natural sources",
    "nucleic acids",
    "nucleicacids",
    "octyl dodecanol",
    "oestrogen",
    "oils",
    "oleic acid",
    "oleicacid",
    "oleicalcohol",
    "oleoic oil",
    "oleth",
    "oleyl myristate",
    "palmitamide",
    "palmitamine",
    "palmitate",
    "palmitic acid",
    "panthenol",
    "panthenyl",
    "polysorbates",
    "polypeptides",
    "potassium lactate",
    "progesterone",
    "propyleneglycol",
    "provitamin a",
    "provitamin b-5",
    "provitamin d-2",
    "quinoline yellow",
    "red 40",
    "rennet",
    "rennin",
    "ribonucleic acid",
    "rna",
    "saccharide hydrolysate",
    "sorbitan beeswax",
    "sorbitanmonooleate",
    "sorbitanmonostearate",
    "sorbitantrioleate",
    "sorbitantristearate",
    "sponge",
    "squalane",
    "squalene",
    "stearamide",
    "stearamine",
    "stearamine oxide",
    "stearate",
    "stearates",
    "stearic acid",
    "stearic hydrazide",
    "stearicacid",
    "stearin",
    "stearone",
    "stearoxytrimethylsilane",
    "stearoyl lactylic acid",
    "stearyl acetate",
    "stearyl alcohol",
    "stearyl alcohol sterols",
    "stearyl betaine",
    "stearyl caprylate",
    "stearyl citrate",
    "stearyl glycyrrhetinate",
    "stearyl heptanoate",
    "stearyl imidazoline",
    "stearyl octanoate",
    "stearyl stearate",
    "stearyl tartrate",
    "stearyltartrate",
    "steroid",
    "sterol",
    "suede",
    "suet",
    "sunset yellow fcf",
    "tartrazine",
    "taurine",
    "testosterone",
    "threonine",
    "vellum",
    "velvet",
    "vitamin a",
    "vitamin b",
    "vitamin b-complex factor",
    "vitamin b1",
    "vitamin b12",
    "vitamin d3",
    "vitamin h",
    "yellow5",
    "yellow6"
]
